export const getEntityId = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value._id ? value._id.toString() : "";
};

export const mergeSelectedIntoOptions = (options, selected) => {
  const list = [...(options || []), ...(selected || [])].filter(Boolean);
  const byId = new Map();

  for (const item of list) {
    if (item && typeof item === "object") {
      const id = getEntityId(item);
      if (id) byId.set(id, item);
    }
  }

  return Array.from(byId.values());
};

export const buildLookupById = (items) => {
  const map = new Map();
  for (const item of items || []) {
    const id = getEntityId(item);
    if (id) map.set(id, item);
  }
  return map;
};

export const getMultiNames = (maybeIdsOrObjects, fallbackObject, lookup) => {
  const list = Array.isArray(maybeIdsOrObjects) ? maybeIdsOrObjects : [];
  const values =
    list.length > 0 ? list : fallbackObject ? [fallbackObject] : [];

  const names = [];
  const seen = new Set();

  for (const v of values) {
    if (!v) continue;

    if (typeof v === "object") {
      const id = getEntityId(v);
      const name = v?.name;
      const key = id || name;
      if (name && key && !seen.has(key)) {
        seen.add(key);
        names.push(name);
      }
      continue;
    }

    if (typeof v === "string") {
      const item = lookup?.get(v);
      const name = item?.name;
      if (name && !seen.has(v)) {
        seen.add(v);
        names.push(name);
      }
    }
  }

  if (names.length === 0 && fallbackObject?.name) {
    return fallbackObject.name;
  }

  return names.join(", ") || "N/A";
};
